import * as React from "react";
import DemoButtons from "./Utiilities/DemoButtons";
import ImageSction1 from "../Assests/Images/Ed365/ImageSection1.png";
import Plans from "./Utiilities/Plans";
import Accordion from "./Utiilities/AccordionItem";
import SpecailButtons from "./Utiilities/SpecialButtons";
import Header from "./Header and Footer/Header";
import Footer from "./Header and Footer/Footer";
import ScrollToTop from "./Utiilities/ScrolltoTop";
import G2Badge from "./Utiilities/G2Badge";
import TabsWithImage from "./Utiilities/TabsWithImage";
import Availability from "./Utiilities/Availability";
import OurClients from "./Utiilities/OurClients";
import Integration from "./Utiilities/Integration";
import { MyContext } from "../App";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import GetOfferPage from "./Utiilities/GetOfferPage";
import CustomPlans from "./Utiilities/CustomPlans";
import Azuer from "./Utiilities/Azuer";
import OverviewCommon from "./GlobalMultiple/OverviewCommon";
import CyberSecurity from "./Utiilities/CyberSecurity";
import OverviewCommonET from "./GlobalMultiple/OverviewCommonET";
import LogoSlider from "./Utiilities/Slider";
import { RxCross1, RxHamburgerMenu } from "react-icons/rx";
import { Dropdown, PrimaryButton, TextField } from "@fluentui/react";
import OverviewCommonTMS365 from "./GlobalMultiple/OverviewCommonTMS365";
import Thanku from "./Utiilities/Thanku";
import Trustedbylogo from "./GlobalMultiple/Trustedbylogo";
// import { mouseflow} from "react-mouseflow";
const logos = [
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/soc_142hvt-qc.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/compliants_tM_PrC8N0Z.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/iso_D4yJ25IRn.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/microsoft_vdp9CYFMBj.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/Best%20ROI%201_96Mf_DosK.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/medal%20(2)_JiluXJRGNl.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/Best%20support%201_IGpX8xxqe3.svg",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png",
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/great-place_C3JVU5GXk.png",
];
function TMS365() {


    //GTM
    const script = document.createElement("script");
    script.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        
        gtag('consent', 'default', {
          'ad_storage': 'denied',
          'analytics_storage': 'denied',
          'functionality_storage': 'denied',
          'security_storage': 'granted',
          'wait_for_update': 500
        });
      `;
    document.head.appendChild(script);

    // React.useEffect(() => {
    //   mouseflow.initialize("d74e23c0-0490-4d54-925d-b4ea1ae7151a");
    //   }, []);
    const [ham, setHam] = React.useState(false);
    const AppName = React.useContext(MyContext);
    const [isLightboxOpen, setLightboxOpen] = React.useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = React.useState("");
    const [isVideoPlaying, setIsVideoPlaying] = React.useState(false);
    const openLightbox = (imageUrl) => {
        setSelectedImageUrl(imageUrl);
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
    };
    const getEmbedUrl = (url) => {
        if (url.includes("youtube.com/watch?v=")) {
            return url.replace("watch?v=", "embed/");
        } else if (url.includes("youtu.be/")) {
            const videoId = url.split("youtu.be/")[1];
            return `https://www.youtube.com/embed/${videoId}`;
        } else if (url.includes("vimeo.com/")) {
            const videoId = url.split("vimeo.com/")[1];
            return `https://player.vimeo.com/video/${videoId}`;
        } else {
            return url; // fallback for direct video links
        }
    };
    const handlePlayClick = () => {
        setIsVideoPlaying(true); // When play icon is clicked, play the video
    };
    const handleCloseVideo = () => {
        setIsVideoPlaying(false); // Close the video
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    // React.useEffect(() => {
    //   document.title = "new title"
    // }, []);
    // React.useEffect(() => {
    //   mouseflow.initialize("d74e23c0-0490-4d54-925d-b4ea1ae7151a");
    //   }, []);
    React.useEffect(() => {
        document.title = "Task 365 | Best SharePoint Task Management Software";
        const metaDescription = document.querySelector("meta[name='description']");
        if (metaDescription) {
            metaDescription.setAttribute(
                "content",
                "Plan, assign, track tasks across Teams, SharePoint, and Outlook. Task 365 keeps work organized, visible & on schedule to keep every team aligned and productive"
            );
        } else {
            const newMeta = document.createElement("meta");
            newMeta.name = "description";
            newMeta.content = "Plan, assign, track tasks across Teams, SharePoint, and Outlook. Task 365 keeps work organized, visible & on schedule to keep every team aligned and productive";
            document.head.appendChild(newMeta);
        }
    }, []);
    // const AppName = React.useContext(MyContext);

    // const [isLightboxOpen, setLightboxOpen] = React.useState(false);
    // const [selectedImageUrl, setSelectedImageUrl] = React.useState("");

    // const openLightbox = (imageUrl) => {
    //   setSelectedImageUrl(imageUrl);
    //   setLightboxOpen(true);
    // };

    // const closeLightbox = () => {
    //   setLightboxOpen(false);
    // };

    const accordionItems = [
        {
            title: "What is Task 365 / Task management 365 and what is its functionality?",
            content: `Task 365 is a smart task-management tool, which is part of Microsoft 365. It helps the team to organize work, set priorities and speed up task completion. It links up with the applications that you use already such as Teams, SharePoint, Outlook, and Planner, so that you can have a view of your tasks, schedules, and conversations all at one place. It highlights the urgent work, creates a simple to understand summary, and handles the repetitive tasks so the team can focus on the crucial ones.`,
        },
        {
            title: `Why is SharePoint Task Management better than Microsoft Planner or To Do?`,
            content: `Perfect for basic task lists. SharePoint Task  365 includes AI Copilot assistance, intelligent summaries, multi-project tracking, and automation. It gets to know your workflow to prioritize it, enables you to add any custom fields, change to List, Board, Calendar, Timeline views, and provides extensive performance insight, all in a single system. It is made to power teams that require greater power than mere lists can provide.`,
        },
        {
            title: `Does SharePoint Task 365 / Task management 365 meet the standards of data-protection?`,
            content: `There is security at every level. SharePoint Task 365 is backed by the Microsoft 365 enterprise level security that safeguards data such as Fortune 500 businesses. You can choose who sees or edits tasks, meet industry compliance standards, keep data encrypted, and get regular security updates. Your team’s work stays protected, secure, and always compliant.`,
        },
        {
            title:
                "How does the AI Copilot make my workday easier?",
            content: `AI Copilot is the AI that supports your work like a human and solves everyday problems with tasks. It gives instant tips that are useful, databases and organizes tasks depending on their urgency, handles repetitive tasks to save you hours every week, gets familiar with your team performance and gives intelligent follow-up suggestions, and ensures that no one misses out on the information without having to give status updates. `,
        },
        {
            title: "Does Task 365 / Task management 365 support multiple projects at once?",
            content: `Yes. The best feature is multi-project tracking. Watch every project on a single dashboard, monitor live progress on all teams, switch between views instantly, spot problems early and maintain a clear view of all initiatives. `,
        },
        {
            title: "What type of reporting and analytics is offered by Task 365 / Task management 365?",
            content: `Task 365 provides robust performance data in an easy-to-use dashboards and reports. Monitor data on productivity, track the rate at which tasks are completed, identify slowdowns, time by project type, generate report templates to be used by stakeholders, and make decisions based on data. The analytics not only show what is happening but also why, which will enable you to keep on improving performance. `,
        },
        {
            title: `Which currency are the prices listed in?`, content: (
                "All prices are listed in USD."

            )
        },
    ];
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Task 365 | Best SharePoint Task Management Software</title>
                    <meta
                        name="description"
                        content="Plan, assign, track tasks across Teams, SharePoint, and Outlook. Task 365 keeps work organized, visible & on schedule to keep every team aligned and productive"
                    />
                </Helmet>
                <ScrollToTop />
                <div className={`HR_MainHeaderSection HR_panelHeader`} style={{ background: "#000" }}>
                    <div className="HR_FlexCenterSpcBetween ETHR_FlexCenterSpcBetween">
                        <div className="HR_LogoSection">
                            <img
                                src={
                                    AppName == "Apps365"
                                        ? "https://ik.imagekit.io/zn4au2jftpm5/Apps365/Logos/apps365white_yKjtDjv_y.png"
                                        : "https://ik.imagekit.io/zn4au2jftpm5/hr365/LOGO/91d92cd8-0bec-4bcc-8a8a-b069094eb852_BmoafHbFDy.png"
                                }
                                alt="Apps 365"
                            />
                            {""}


                            <div className="DB_button">
                                <DemoButtons StickyButton={true} getStarted={true} openDialog={true} Dialogheading={"See how Task 365 brings clarity, improves task visibility, and adds control to everyday work"} DialogDescription={"Share your details and our team will walk you through how it works."} />
                            </div>
                            <div>
                                <span className="MBHAMBURGER" onClick={() => setHam(!ham)}>
                                    <RxHamburgerMenu />
                                </span>
                                {/* <span className="MBHAMBURGER" onClick={() => setHam(!ham)}> ≡</span> */}
                            </div>
                        </div>

                        <div className="HR_FlexCenterSpcBetween">
                            <div
                                className="HR_navMenu ETHR_navMenu LMSNavmenu "
                                style={{ paddingLeft: "0" }}
                            >
                                <span>
                                    <ul>
                                        <li>
                                            <div className="ET-logoIcons Task-365-brandimage LMSLogoIconsStyles">
                                                <img
                                                    alt="MainImage"
                                                    src="https://ik.imagekit.io/cubiclogics/App%20Logos/White-logos/Task-Management-365-white.png?updatedAt=1765794165717"
                                                ></img>
                                                <span className="Task-Heading-name">Task 365</span>
                                            </div>
                                        </li>
                                        <li>
                                            <a href="#Features">Features</a>
                                        </li>

                                        <li>
                                            <a href="#ClientsSpeakTestimonial">Testimonial</a>
                                        </li>
                                        <li>
                                            <a href="#Integration-ET">Integration</a>
                                        </li>
                                        <li>
                                            <a href="#pricing">Pricing</a>
                                        </li>
                                    </ul>
                                </span>
                            </div>

                            <div className="MB_button">
                                <DemoButtons StickyButton={false} getStarted={false} />
                            </div>

                            <div className="MB_button">
                                <DemoButtons StickyButton={true} getStarted={false} />
                            </div>
                        </div>
                    </div>
                </div>

                {ham ? (
                    <div
                        className="MBHB"
                        style={{
                            position: "fixed",
                            zIndex: "9",
                            top: "0vw",
                            paddingTop: "0.4vw 3vw",
                            background: "var(--panelBgColor)",
                            height: "100vh",
                        }}
                    >
                        <div className="mbflex TaskStyles">
                            <div className="HR_LogoSection">
                                <img
                                    src={
                                        "https://ik.imagekit.io/apps365/App-Logos/Apps365-black-logo-216x40px.png"
                                    }
                                    alt={AppName}
                                />
                                {/* <a href="https://www.apps365.com" target="_blank" rel="noreferrer">
                <img src={"https://ik.imagekit.io/apps365/App-Logos/Apps365-black-logo-216x40px.png"} alt="Apps365" />
                {""}
              </a> */}
                            </div>

                            {ham ? (
                                <div
                                    onClick={() => setHam(!ham)}
                                    style={{ margin: "12px 0px" }}
                                >
                                    <span className="cross">
                                        <RxCross1 />
                                    </span>
                                </div>
                            ) : (
                                <div onClick={() => setHam(!ham)}>
                                    <span className="cross">+</span>
                                </div>
                            )}
                        </div>
                        <div>
                            <span>
                                <ul className={`${ham ? "mbmenu" : ""}`}>
                                    <li>
                                        <div className="ET-logoIcons ET-logoIconsOnMobileView ">
                                            <img
                                                alt="MainImage"
                                                src="https://ik.imagekit.io/cubiclogics/App%20Logos/TaskManagement365.webp"
                                            ></img>
                                            <h3 className="HR_primaryclr">Task 365</h3>
                                        </div>
                                    </li>
                                    <li>
                                        <a href="#Features" onClick={() => setHam(false)}>
                                            Features
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#ClientsSpeakTestimonial"
                                            onClick={() => setHam(false)}
                                        >
                                            Clients
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#Integration-ET" onClick={() => setHam(false)}>
                                            Integration
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#pricing" onClick={() => setHam(false)}>
                                            Pricing
                                        </a>
                                    </li>
                                </ul>
                            </span>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {/* <Header HR365header="ET365" /> */}

                <div
                    style={{
                        backgroundColor: "unset",
                        background:
                            "linear-gradient(110deg, #daeaf6, #e8def8, #fdf0f0, #e8def8, #daeaf6)",
                    }}
                >
                    <div
                        className="HR_panel"
                        style={{
                            padding: "3vw 5vw 1vw 3vw",
                            background: "linear-gradient(45deg, #daeaf6, #e8def8, #fdf0f0, #e8def8, #daeaf6)",
                        }}
                    >
                        <div className="HR_FlexCenterSpcBetween HR_ParentSection1 ET365HomepageParentsection">
                            <div className="HR_Section1LeftSide LMS365-HR_Section1LeftSide">
                                <h1
                                    className="HR_primaryclr"
                                    style={{
                                        fontSize: "3vw !important",
                                        fontWeight: "800 !important",
                                        color: "#333 !important",
                                    }}
                                >
                                    AI-powered task management built for Microsoft 365 -  <span className="SubheadingLMS365">One system to plan, track, and deliver work,  without switching tools</span>
                                </h1>
                                <span className="ET365-HerosectionSubheading"></span>
                                <p
                                    className="HR_textclr LMSHR_textclr" style={{ marginTop: "0.4vw" }}

                                >
                                    <span >
                                        {" "}
                                        <b> Task 365</b> brings task planning, ownership, and progress tracking directly into Microsoft Teams, SharePoint, and Outlook.
                                    </span>
                                    <span >
                                        {" "}
                                        With early issue detection, delay prediction, and deadline suggestions, teams stay focused, aligned, and consistently deliver on time,without adding another platform.
                                    </span>
                                </p>

                                <DemoButtons
                                    LMS365="LMS365"
                                    demobtnText="See Task 365 Live in Action"
                                />
                            </div>
                            <div className="HR_Section1RightSide" style={{ width: "60%" }}>
                                <img
                                    className="HeroSectionImageStyles"
                                    style={{ width: "100%" }}
                                    alt="Task 365"
                                    src="https://ik.imagekit.io/apps365/Apps365/TM/Lp-task-management.webp"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <Trustedbylogo />
                        <div style={{ paddingTop: "1vw" }}></div>
                        <OverviewCommonTMS365
                            MainHeading="Are your employees juggling multiple tools just to complete training?"
                            MainDescription=""
                            MainImageAlt="ET365"
                        />
                        <div style={{ background: "linear-gradient(200deg, rgb(199 231 255 / 59%), rgb(226 208 255 / 64%), rgb(229 221 252 / 75%), rgb(217 206 236 / 67%), rgb(196 218 235 / 60%))" }}>
                            <h2
                                style={{ margin: "0px", paddingTop: "1.5vw", color: "#333" }}
                                className="HR_heading  ETHR_heading LMS_FeatureHeading"
                            >
                                Powerful Task Management Features Built for Faster Execution
                            </h2>

                            <p className="AI-DescriptionStyles" style={{ margin: "0", marginBottom: "2vw" }}>
                                Help your team stay organized, plan work clearly, execute faster, and deliver work with complete clarity—within Microsoft 365.
                            </p>
                            <div style={{ gap: "8vw" }} className="FeaturesWithImages FeaturesWithImages1" >
                                <div>
                                    <h2>Connects Natively with Microsoft Planner</h2>
                                    <p className="AI-DescriptionStyles">Plan, assign, and track tasks directly through Microsoft Planner while Task Management 365 keeps everything synced across Teams, Outlook, and SharePoint.
                                    </p>
                                    <p className="AI-DescriptionStyles">Your team stays aligned and gains clear visibility across projects without switching tools.
                                    </p>
                                </div>
                                <div style={{ width: "25%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Apps365/TM/MSplanner.webp" alt="" />
                                </div>
                            </div>
                            <div className="FeaturesWithImages">
                                <div>
                                    <h2>Connected Task Hub </h2>
                                    <p className="AI-DescriptionStyles">All tasks, files, updates, and conversations are managed in one centralized hub. Teams stay aligned with a shared view of work, eliminating silos and fragmented communication.
                                    </p>
                                </div>
                                <div style={{ width: "65%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Apps365/TM/Connected-Task-Hub.png" alt="" />
                                </div>
                            </div>
                            <div className="FeaturesWithImages FeaturesWithImages1" >
                                <div>
                                    <h2>Clear Task Creation & Ownership</h2>
                                    <p className="AI-DescriptionStyles">Create tasks with defined owners, deadlines, and details in one place. Clear ownership ensures accountability and keeps work moving without follow-ups or confusion.
                                    </p>
                                </div>
                                <div style={{ width: "60%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Apps365/TM/Clear-Task-Creation-&-Ownership.png" alt="" />
                                </div>
                            </div>
                            <div className="FeaturesWithImages" >
                                <div>
                                    <h2>Multi-Project Tracking</h2>
                                    <p className="AI-DescriptionStyles">Track all projects in real time from a single screen. Leaders gain instant visibility into progress, risks, and workload across the organization
                                    </p>
                                </div>
                                <div style={{ width: "57%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Apps365/TM/Multi-Project-Tracking.png" alt="" />
                                </div>
                            </div>

                            <div className="FeaturesWithImages FeaturesWithImages1" >
                                <div>
                                    <h2>Performance Insights</h2>
                                    <p className="AI-DescriptionStyles">Use dashboards and reports to monitor progress and identify issues early. Transparent insights support better decisions and consistent execution at scale.
                                    </p>
                                </div>
                                <div style={{ width: "65%" }}>
                                    <img src="https://ik.imagekit.io/apps365/Apps365/TM/Performance-Insights.png" alt="" />
                                </div>
                            </div>
                            <div class="et-feature-container LMS365FeatureCards" style={{ paddingTop: "0" }}>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Apps365/TM/Reminders-&-Notifications.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">
                                        Reminders & Notifications
                                    </h3>
                                    <p class="et-feature-desc">
                                        Automatic alerts keep work on schedule and ensure critical tasks are never missed.
                                    </p>
                                </div>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Apps365/TM/Custom-Fields.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Custom Fields</h3>
                                    <p class="et-feature-desc">
                                        Tag tasks by priority, status, or category to stay focused and organized.
                                    </p>
                                </div>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Apps365/TM/Flexible-Views.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Flexible Views</h3>
                                    <p class="et-feature-desc">
                                        Switch between List, Board, Calendar, or Timeline views to plan work effectively.
                                    </p>
                                </div>
                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Apps365/TM/Smart-Scheduling.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Smart Scheduling</h3>
                                    <p class="et-feature-desc">
                                        Plan ahead using a clear calendar view to manage time, balance workloads, and meet deadlines comfortably.
                                    </p>
                                </div>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Apps365/TM/Team-Collaboration.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Team Collaboration</h3>
                                    <p class="et-feature-desc">
                                        Share updates, coordinate work, and delegate tasks directly through Microsoft Teams.
                                    </p>
                                </div>

                                <div class="et-feature-card">
                                    <img
                                        decoding="async"
                                        src="https://ik.imagekit.io/apps365/Apps365/TM/Built-for-Microsoft-365.svg"
                                        title=""
                                        alt=""
                                        loading="lazy"
                                    ></img>
                                    <h3 class="et-feature-title">Built for Microsoft 365</h3>
                                    <p class="et-feature-desc">
                                        Works seamlessly within Microsoft Teams, SharePoint & Outlook—no new platform required.
                                    </p>
                                </div>

                            </div>
                        </div>
                        <div
                            style={{
                                padding: "3vw",
                                background: "none",
                                paddingBottom: "2vw",
                            }}
                            className="overviewsection ETOverViewSection"
                        >
                            <h2 className="HR_heading" style={{ marginBottom: "0.5vw", color: "#333", margin: "0", paddingTop: "1.5vw" }}>
                                Why Choose Task 365?
                            </h2>

                            <p className="AI-DescriptionStyles" style={{ margin: "0" }}>
                                When everything is organized in one system, work becomes more manageable. Task 365 integrates tasks, priorities, and collaboration, ensuring your team always knows the next step. With built-in automation and reusable templates, manual effort is minimized, helping teams save time, stay in sync, and work with confidence.

                                {" "}
                            </p>

                            <div
                                className="cybersection cybersectionET"
                                style={{ background: "none", paddingBottom: "1vw", paddingTop: "2vw" }}
                            >
                                <CyberSecurity PageName="ET365" />
                            </div>
                        </div>

                        <div></div>

                        <section className="sec">
                            <div>
                                <div
                                    className="easy"
                                    style={{ background: "none", padding: "0vw 5vw 3vw 5vw" }}
                                >
                                    <div className="Avilcard1 LMS_Avilcard1" >
                                        <div className="AvilcardStyle">
                                            <div className="stickerStyles">
                                                <div className="sticker">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/customer-support_wPk-OuZ23.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                            </div>
                                            <h3 className="custom" style={{ color: "#2323CE" }}>
                                                Customer Support
                                            </h3>
                                            <p className="easypera">
                                                Our support team merges technical prowess with sincere
                                                care, fostering trust through expertise and empathy.
                                                They build lasting relationships, transcending mere
                                                service to create meaningful connections.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="availcard2">
                                        <div className="cd1">
                                            <div
                                                className="c1"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon1">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/setting_z7IzKFspuo.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt1">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        {" "}
                                                        AI Enabled Apps
                                                    </h3>
                                                    <p className="easypera">
                                                        Our innovative apps are built with the options of
                                                        Azure AI, Copilot, and custom AI solutions.
                                                    </p>
                                                </div>
                                            </div>

                                            <div
                                                className="c2"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon2">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/interface%20(1)_Bn8jFsKJE.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt2">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Modern UI/UX
                                                    </h3>
                                                    <p className="easypera">
                                                        Every app is crafted using the latest Fluent UI,
                                                        ensuring seamless functionality across all devices.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cd2">
                                            <div
                                                className="c3"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon3">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/cloud-storage_wjvbbJkVt.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt3">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Swift Deployment
                                                    </h3>
                                                    <p className="easypera">
                                                        Choose any deployment
                                                        method—Teams,
                                                        Outlook, or SharePoint—that suits your preferences.
                                                    </p>
                                                    <span id="ClientsSpeakTestimonial" />
                                                </div>
                                            </div>
                                            <div
                                                className="c4"
                                                style={{
                                                    background: "#f9faffbb",
                                                }}
                                            >
                                                <div className="icon4">
                                                    <img
                                                        src="https://ik.imagekit.io/zn4au2jftpm5/refresh__OBoe0tcU.png"
                                                        alt="Description of Image"
                                                        class="supportimage"
                                                    />
                                                </div>
                                                <div className="txt4">
                                                    <h3 className="Swift" style={{ color: "#2323CE" }}>
                                                        Free Updates{" "}
                                                    </h3>
                                                    <p className="easypera">
                                                        Our valued subscribers enjoy unlimited support,
                                                        enhancements, features, and updates.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    {/* <GetOfferPage Type="Image"/> */}

                    {/* <div id="features" className="IdChanges"></div>
                <div style={{ background: "#eff2fb", margin: "0", paddingTop: "2vw" }}>
                    <h2 className="HR_heading" style={{ margin: "0" }}>Key Features of Expense 365</h2>
                    <p>Gain full visibility into your business spending with the power of reliable business expense tracker.
                    </p>
                    <p style={{ margin: "0" }}> Minimize admin work and maximize financial visibility effortlessly.
                    </p>
                </div>
                <div>
                    <TabsWithImage tabs={tabs1} />
                </div>
                <div>
                    <TabsWithImage tabs={tabs2} />
                </div> */}

                    <div id="client" className="IdChanges"></div>
                    <div
                        className="HR_whitesection"
                        style={{ background: "none", padding: "0vw 5vw 1vw 5vw" }}
                    >
                        <h2 className="HR_heading HR_MT" style={{ color: "#333", margin: "0" }}>Loved by Teams. Trusted by Leaders.</h2>
                        <p class="et-integration-subtitle CustomerReviewStyles AI-DescriptionStyles">
                            See how teams and businesses achieve more, stay organized, and manage projects better with Task 365.
                        </p>
                        <div className="HR_MT">
                            <OurClients />
                        </div>
                    </div>
                    <div class="et-integration-section LMS_integration-section" >
                        <div style={{ width: "100%" }}>
                            <h2 class="et-integration-title lMS_integration-title" >
                                Powerful Integrations,<br /> Zero Platform Switching
                            </h2>
                            <p class="et-integration-subtitle lMS_integration-subtitle" >
                                Task 365 integrates seamlessly with Microsoft Teams, Outlook, SharePoint, and other Microsoft 365 tools to streamline task execution. By consolidating tasks, updates, and conversations in one unified environment, teams gain clarity, accountability, and complete visibility into their work.
                            </p>
                            <span id="pricing" />
                        </div>
                        <div style={{ width: "61%", margin: "0", padding: "0vw", }}>
                            <img src="https://ik.imagekit.io/apps365/Apps365/TM/Task-managemet.gif" />


                        </div>


                    </div>

                    <div id="integration" className="IdChangesIntegration"></div>

                    <div className="IdChanges"></div>
                    <div className="HR_whitesection" style={{ background: "none" }}>
                        <h2 className="HR_heading HR_MT" style={{ color: "#333", marginBottom: "0vw" }}>
                            Task 365 Pricing & Plans
                        </h2>
                        <p className="AI-DescriptionStyles" style={{ margin: "0", marginBottom: "1vw" }}>
                            Task 365 is your all-in-one solution for smarter task management and team productivity.

                        </p>
                        <div className="HR_MT">
                            <div>
                                <Plans appName={"Task 365"} />
                            </div>
                        </div>
                    </div>
                    <div className="AzureBoxStyles_LMS">
                        <div className="AzureBoxStyles_LMS_1">
                            <img style={{ width: "66%" }} src="https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png" alt="" />
                            <h3 className="Azureheading" style={{ marginBottom: "0.8vw !important", paddingTop: "0.41vw" }}>Live on Azure</h3>
                            <p className="AzureText" style={{ textAlign: "center" }}>Buy directly from Azure Marketplace or via your enterprise agreement.</p>
                            <a className="Hr_Link" href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1">  Get started on Azure</a>
                        </div>
                        <div className="AzureBoxStyles_LMS_2" >

                            <img style={{ width: "65%" }} src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/Random-Images/Untitled%20design%20(21)_nD6tRPn1n9.png" alt="" />
                            <h3 className="Azureheading">Special Pricing for NPOs</h3>

                            <SpecailButtons userCount={"50+"} LMS365="LMS365" hideSpecialrequest="hideSpecialrequest" SpecailButtonsText="Non-profits and government-funded educational institutes can avail exclusive rates." />
                        </div>
                        <div className="AzureBoxStyles_LMS_3">

                            <img style={{ width: "40%" }} src="https://ik.imagekit.io/apps365/Apps365/HD/Untitled%20design%20(27).webp" alt="" />
                            <h3 className="Azureheading" style={{ marginBottom: "0.8vw !important", paddingTop: "0.3vw" }}>Enterprise Pricing for 50+ Users
                            </h3>

                            <SpecailButtons userCount={"50+"} LMS365="LMS365" hideNPOrequest="hideNPOrequest" SpecailButtonsTextUser="Organizations with more than 50 users can avail special pricing." />
                        </div>


                    </div>
                    {/* <div
            className="Azuersection"
            style={{
              background: "none",
              paddingBottom: "0vw",
              paddingTop: "0vw",
            }}
          >
            <div className="AzureLogoText">
              <a
                href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1"
                target="_blank"
              >
                <img
                  className="AzureImage"
                  src="https://ik.imagekit.io/zn4au2jftpm5/hr365/azure1_9hVzCGU2W.png"
                  alt="Azure"
                />
              </a>
              <p className="AzureText">
                Using Azure? now you can{" "}
                <a
                  href="https://azuremarketplace.microsoft.com/en-us/marketplace/apps?search=hr365bizapps365&page=1"
                  target="_blank"
                >
                  buy
                </a>
                on Azure Marketplace or using your enterprise agreement
              </p>
            </div>
          </div> */}
                    {/* <SpecailButtons userCount={"50+"} /> */}
                    {/* <div class="et-integration-section">
                    <h2 class="et-integration-title">Seamlessly Track and Control Your Business Spending with Expense 365</h2>
                    <p class="et-integration-subtitle">
                        Experience hassle-free expense management.
                    </p>
                    </div> */}

                    <span className="privacytext"></span>
                    <div id="faq" className="IdChangesIntegration"></div>
                    <div class="et et-demo-section">
                        <h1 class="et et-demo-heading" style={{ margin: "0", padding: "0", color: "#333", paddingTop: "2vw" }}>
                            Centralize all Your Tasks in One Place
                        </h1>
                        <p class=" AI-DescriptionStyles" style={{ marginBottom: "0", padding: "0vw 7vw", color: "#000" }}>
                            Discover how leading organizations  are using Task 365 to improve task execution, increase accountability, and drive productivity within their teams.
                        </p>
                        <p class="et et-demo-subtext AI-DescriptionStyles">
                            Experience the power of smarter task management today!
                        </p>
                        {/* <div class="et et-button-group">
              <DemoButtons
                hideDemoBtn="fasle"
                trailbtnText="Start Your 14-Day Free Trial button"
              />
            </div> */}
                        <form
                            id="lpgetstartedform"
                            className="lpgetstartedformclass "
                            style={{ padding: "2vw", background: "#f9faffbb", borderRadius: "0.5vw", paddingBottom: "0vw" }}
                        >
                            <div className="FooterContainer">
                                <div className="BottomFormleftimg">
                                    <img className="BottomFormImage" src="https://ik.imagekit.io/zn4au2jftpm5/Apps365/LMS365/LMS365-bottom-form_V3Jq3dsZk.png" alt="" />
                                </div>
                                <div className="FieldsButtonStyles">
                                    <div className="FormFieldStyles">
                                        <h3>Book a Personalized Task 365 Demo!</h3>
                                        <DemoButtons LMS365demoForm={true} />
                                    </div>
                                    {/* <div className="ButtonandPrivacyText">
                    <PrimaryButton
                      style={{ background: "var(--btn-bg-color)", border: "none", fontSize: "1.1vw" }}
                      id="lpgetstartedsubmitbutton"
                      className="subButton"
                    // onClick={() => submitRequest("getstarted")}
                    >
                      {"Select a Time Slot"}

                    </PrimaryButton>

                  </div> */}
                                </div>
                            </div>
                        </form>
                        <div>
                            <h3 className="HR_faq">Frequently Asked Questions</h3>
                            <Accordion items={accordionItems} />
                        </div>
                    </div>
                </div>
                <Footer ET365={"ET365"} />

                {/* <Thanku pageurl="http://lp.apps365.com/task-management-365"/> */}
            </HelmetProvider>
        </>
    );
}
export default TMS365;
